import React from "react";
import { IconButton } from "@mzc-pdc/ui";
import { IconFolderAdd } from "@mzc-cloudplex/icons";
import useCheckPermission from "@hooks/useCheckPermission";

const TreeViewActions = ({ onToggleModal }) => {
    const FOLDERS_PERMISSIONS = useCheckPermission({ scope: "Project", domain: "Folders" });

    return (
        <>
            <IconButton
                circled
                size={"medium"}
                onClick={(e) => {
                    e.stopPropagation();
                    onToggleModal("createFolder", true);
                }}
                disabled={!FOLDERS_PERMISSIONS.EDIT}
            >
                <IconFolderAdd size={16} color={"greySecondary"} />
            </IconButton>
        </>
    );
};

export default TreeViewActions;
